import { BrowserRouter } from "react-router-dom";
import DataCollection from "./common/DataCollection";
import Home from "./common/Home";
import { Routes, Route } from "react-router-dom";
import List from "./common/List";
import SignatureThumb from "./common/Signature&Thumb";
import SignatureThumbList from "./common/Signature&Thumblist";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/data-collection/:orgCode/:userId"
        element={<DataCollection />}
      />
      <Route
        path="/signature-thumb/:orgCode/:userId"
        element={<SignatureThumb />}
      />
      <Route path="/list/:orgCode" element={<List />} />

      <Route
        path="/signature-list/:orgCode/:year/:seasonId"
        element={<SignatureThumbList />}
      />
    </Routes>
  </BrowserRouter>
);

export default App;
